import type { Action, Reducer } from 'redux';

import { ACTION_TYPES } from './actionTypes.const';
import type {
  ImportHistoricalWorkAction,
  ImportHistoricalWorkActionHandler,
  ImportHistoricalWorkActionType,
  ImportHistoricalWorkState,
} from './types';

const initialState = {
  isPartNumberOnlySearch: true,
  isRootPartOnlySearch: true,
};

const ACTION_TYPE_TO_HANDLER_MAP: Record<
  ImportHistoricalWorkActionType,
  ImportHistoricalWorkActionHandler
> = {
  [ACTION_TYPES.toggleIsPartNumberOnlySearch]: (state) => ({
    ...state,
    isPartNumberOnlySearch: !state.isPartNumberOnlySearch,
  }),
  [ACTION_TYPES.toggleIsRootPartOnlySearch]: (state) => ({
    ...state,
    isRootPartOnlySearch: !state.isRootPartOnlySearch,
  }),
};

const isImportHistoricalWorkAction = (
  action: Action,
): action is ImportHistoricalWorkAction =>
  Object.values(ACTION_TYPES).includes(action.type);

/* eslint-disable default-param-last */
export const importHistoricalWorkReducer: Reducer<ImportHistoricalWorkState> = (
  state = initialState,
  action,
) => {
  /* eslint-enable default-param-last */
  const actionHandler = isImportHistoricalWorkAction(action)
    ? ACTION_TYPE_TO_HANDLER_MAP[action.type]
    : null;

  return actionHandler?.(state) ?? state;
};
